import { SellerAddressUi } from '@/components/Seller/SellerProfile/Address/SellerAddressUi';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateSellerAddress } from '@/data/api/request/sellerRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateSellerAddress() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: { sellerId: string; data: SellerAddressUi }) =>
      updateSellerAddress({
        sellerId: args.sellerId,
        sellerAddressRequest: {
          street: args.data.street,
          exterior_number: args.data.exteriorNumber,
          interior_number: args.data.interiorNumber,
          zip_code: args.data.postalCode,
          colony: args.data.colonia,
        },
      }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.seller.list] });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.seller.address, variables.sellerId],
      });
      showSnackSuccess('Datos actualizados');
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });

  return mutation;
}
